export default abstract class AnalyticsEvent {
  public abstract readonly name: string;
  public abstract properties: Record<string, any>;
}
